// 直播列表
import React from "react";

const columns = () => {
  return [
    {
      name: 'id',
    },
    {
      title: '名称',
      name: 'name',
      dataIndex: "name",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "直播类型",
      name: "liveType",
      dataIndex: "liveType",
      tableItem: {},
      searchItem: {
        type: 'select',
      },
      dict: [
        { code: 1, codeName: "视频直播" },
        { code: 2, codeName: "互动直播" },
        { code: 3, codeName: "点播" },
        { code: 4, codeName: "远程认证" },
        { code: 5, codeName: "直播课堂" },
        { code: 6, codeName: "远程评估" },
      ],
    },
    {
      title: "直播分类",
      name: "categoryName",
      dataIndex: "categoryName",
      tableItem: {}
    },
    {
      title: "开播时间",
      name: "startDate",
      dataIndex: "startDate",
      width: 150,
      tableItem: {}
    },
    // {
    //   title: "直播状态",
    //   name: "state",
    //   dataIndex: "state",
    //   tableItem: {},
    //   dict: [
    //     { code: 1, codeName: "草稿" },
    //     { code: 2, codeName: "预告中" },
    //     { code: 3, codeName: "直播中" },
    //     { code: 4, codeName: "已结束" }
    //   ],
    //   searchItem: {
    //     type: "select"
    //   },
    // },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'interactLive/listByPage',
    ...api
  }
}

const live = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    rowName: 'name',
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default live
